import { costTrackerFields } from 'src/enums/cost-tracker';
import { GroupedCostTrackerItem } from 'src/common/interfaces/cost-tracker.interfaces';

export const sum = (itemList: any[], propName: string) =>
  itemList.reduce((sum: number, item) => sum + Number(item[propName]) || 0, 0) || null;

export const getSetionData = (section: GroupedCostTrackerItem) => ({
  ...section,
  costAfe: sum(section.operations, costTrackerFields.COST_AFE),
  costSuggested: sum(section.operations, costTrackerFields.COST_SUGGESTED),
  costActual: sum(section.operations, costTrackerFields.COST_ACTUAL),
  variance: sum(section.operations, costTrackerFields.VARIANCE),
});

export const thousandsSeparators = (input: number | null = null) => {
  const stringInput = input || input === 0 ? input.toString() : '';
  const formatted = stringInput.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
  return formatted;
};

export const removeSpaceSeparators = (input: string | null) => (input ? input.replace(/\s/g, '') : null);
